const EVENT_PROPERTIES = {
    PAGE: 'Page',
    Tab: 'Tab',
    PROPERTY_ID: 'Property ID',
    SEARCH_TAB: 'Search Tab',
    SEARCH_STRING: 'Search String',
};

export default {
    EVENT_PROPERTIES,
};